import { RootStore, StakingStore } from 'bzx-common/src/stores'
import { DialogVM } from 'ui-framework'
import * as mobx from 'mobx'

type StakingVMProps = 'pending' | 'section'

export default class StakingVM {
  rootStore: RootStore
  stakingStore: StakingStore
  pending = false
  section: 'dao' | 'stake' | 'rewards' = 'stake'
  migrationDetailsDialog = new DialogVM({ id: 'staking-migration' })
  private stopAutoSyncData: mobx.IReactionDisposer | null = null

  get stakingAvailable() {
    return this.rootStore.web3Connection.chainId === 1
  }

  /**
   * Helper to set values through mobx actions.
   */
  set(prop: StakingVMProps, value: any) {
    ;(this[prop] as any) = value
  }

  /**
   * Helper to assign multiple props values through a mobx action.
   */
  assign(props: { [key: string]: any }) {
    Object.assign(this, props)
  }

  init() {
    setTimeout(() => {
      this.stopAutoSyncData = mobx.autorun(() => {
        const { chainId, walletAddress } = this.rootStore.web3Connection
        if (chainId === 1 && walletAddress) {
          this.stakingStore.syncData()
        }
      })
    }, 0)
  }

  destroyVM() {
    this.stopAutoSyncData && this.stopAutoSyncData()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.stakingStore = rootStore.stakingStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    this.init()
  }
}
